<template>
  <div class="simple-landing-root">
    <!-- <v-app id="app"> -->
    <!-- <Header /> -->

    <v-main
      id="main"
      class="bg-grey-lighten-3 background-gutter"
    >
      <v-container
        fluid
        class="container pa-0"
      >
        <NuxtPage />
      </v-container>
    </v-main>

    <Footer />
    <!-- </v-app> -->
  </div>
</template>

<style>
@import '~/assets/css/landing-variables.css';
</style>

<style scoped>
.simple-landing-root {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

#main {
  flex: 1;
  background-image: url("@/assets/images/SIZEN17A_33x30a.webp");
  background-position: top center;
  background-repeat: repeat;
  /* height: 200vh; */
  /* height: 240vh; */
}

#main .container {
  padding: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1200px;
}
</style>
